import { getConnectionTypes, getDestinationTypes } from './connectionsApi';
import { ConnectionType } from 'shared/types/ObjectTypes';
import { filter_page_size } from 'shared/api/apiUtils';

export const loadDestinationTypes = async (
  keycloak_token: string,
  page_offset: number,
  destinationTypeSearchInput: any,
  destinationTypes: ConnectionType[],
  // Connections lists every technology; the places that pick a destination
  // still want only the ones that can receive data.
  allTypes: boolean = false,
): Promise<[ConnectionType[], number, Error | null]> => {
  let total_destination_types = 0;
  try {
    const query = {
      limit: filter_page_size,
      offset: page_offset,
      search: destinationTypeSearchInput,
      ordering: 'name',
      previous:
        process.env.REACT_APP_BASE_URL_LOCAL +
        (allTypes
          ? '/v2/integrations/types/?pager=limit&limit='
          : '/v2/integrations/types/?action_type=push&pager=limit&limit=') +
        filter_page_size +
        '&offset=' +
        (page_offset - filter_page_size),
      next:
        process.env.REACT_APP_BASE_URL_LOCAL +
        (allTypes
          ? '/v2/integrations/types/?pager=limit&limit='
          : '/v2/integrations/types/?action_type=push&pager=limit&limit=') +
        filter_page_size +
        '&offset=' +
        (page_offset + filter_page_size),
    };
    const temp = allTypes
      ? await getConnectionTypes(keycloak_token, query)
      : await getDestinationTypes(keycloak_token, query);
    const new_array: ConnectionType[] = destinationTypes.concat(temp.results);
    const duplicates_removed: ConnectionType[] = Array.from(
      new Set(new_array.map((obj) => obj.id)),
    ).map((id) => {
      return new_array.find((obj) => obj.id === id)!;
    });
    const alphabetized = duplicates_removed.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    if (destinationTypeSearchInput.length === 0)
      total_destination_types = temp.count;
    return [alphabetized, total_destination_types, null];
  } catch (err: any) {
    console.log(err);
    return [[], 0, err];
  }
};
